import { LABEL, SECTION, ELLIPSE, SHAPE } from '@adalo/constants'

export const hotkeyMapping = {
  [SECTION]: 'r',
  [ELLIPSE]: 'o',
  [LABEL]: 't',
  [SHAPE]: 'v',
}
